module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('Tabs', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "on-click": _vm.handleTapChange
    },
    model: {
      value: (_vm.tabsValue),
      callback: function($$v) {
        _vm.tabsValue = $$v
      },
      expression: "tabsValue"
    }
  }, _vm._l((_vm.cpList2), function(item, index) {
    return _c('TabPane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formFuzzy
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入专辑名称"
    },
    model: {
      value: (_vm.formFuzzy.albumName),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "albumName", $$v)
      },
      expression: "formFuzzy.albumName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddBtn),
      expression: "showAddBtn"
    }],
    staticClass: "btn_multy_add_new_book",
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": _vm.addAlbum
    }
  }, [_vm._v("新建专辑")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "font-size": "12px"
    },
    attrs: {
      "data": _vm.queryData,
      "header-cell-style": _vm.rowClass,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "专辑ID",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.gotoAlbum(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "专辑名称",
      "align": "center",
      "min-width": "150",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.gotoAlbum(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dbName",
      "label": "书籍品牌",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "res_count",
      "label": "内容数量",
      "align": "center",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "上下架状态",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("未上架")]) : (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("已上架")]) : (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("被下架")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "editor",
      "label": "编辑账号",
      "min-width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "更新时间",
      "align": "center",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate2")(scope.row.updated_at)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "编辑",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit",
            "circle": "",
            "disabled": scope.row.editAble == 0 ? true : false
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddBtn),
      expression: "showAddBtn"
    }],
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-arrow-up"
    },
    on: {
      "click": _vm.shangjia
    }
  }, [_vm._v("上架")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddBtn),
      expression: "showAddBtn"
    }],
    attrs: {
      "type": "info",
      "icon": "el-icon-arrow-down"
    },
    on: {
      "click": _vm.xiajia
    }
  }, [_vm._v("下架")]), _vm._v(" "), (_vm.tabsValue == '预置歌单') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-sort"
    },
    on: {
      "click": _vm.syncAlbumHandle
    }
  }, [_vm._v("同步")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddBtn),
      expression: "showAddBtn"
    }],
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete"
    },
    on: {
      "click": _vm.delAlbums
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44e2c499","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/albumList.vue
// module id = 683
// module chunks = 1